import { useCustomizeHeaderContext } from 'contexts/CustomizeHeaderContext';
import { useEffect } from 'react';

export const useCustomHeaderTitle = (title: string): void => {
  const { setCustomTitle } = useCustomizeHeaderContext();
  useEffect(() => {
    setCustomTitle(title);
    return (): void => setCustomTitle('');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [title]);
};
